import { route } from 'preact-router';
import App from './components/app';
import { getItem, removeAll } from './lib/myStore';
import http from 'fetch-bb';
import 'style/index.styl';

const HTTP_UNAUTHORIZED_CODE = 401;

http.responseInterceptor = (response, status) => {
  if (status === HTTP_UNAUTHORIZED_CODE) {
    removeAll();
    route(`/`);
    return Promise.resolve(response);
  }
  return Promise.resolve(response);
};

http.requestInterceptor = (httpConfig) => {
  httpConfig.headers.push({
    name: 'Authorization',
    value: getItem('token').token
  });
  httpConfig.headers.push({
    name: 'Content-Type',
    value: 'application/json'
  });
  return Promise.resolve();
};

export default App;
